module.exports = __webpack_public_path__ + "img/img (46).df6f651c.jpg";